module.exports = __webpack_public_path__ + "img/about_thumb.84d86caa.png";